module.exports = __webpack_public_path__ + "static/img/authenticationSuccess.1f7d0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/authenticationSuccess.png
// module id = SmHf
// module chunks = 2